import Calendar from "@/utils/calendar";

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 50,
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "移库单号",
    dataIndex: "transferCode",
    key: "transferCode",
    width: 280,
  },
  // {
  //     title: '批次包编码',
  //     dataIndex: 'pkgCode',
  //     key: 'pkgCode',
  // },
  // {
  //     title: '商品SKU',
  //     dataIndex: 'shopProductSku',
  //     key: 'shopProductSku'
  // },
  {
    title: "移库状态",
    dataIndex: "transferStatus",
    key: "transferStatus",
    customRender: (text, record, index) => {
      return { 0: "待确认", 1: "调拨确认", 2: "调拨驳回" }[text];
    },
  },
  {
    title: "源库区",
    dataIndex: "sourceName",
    key: "sourceName",
  },
  // {
  //   title: "订单来源",
  //   dataIndex: "systemSource",
  //   key: "systemSource",
  //   customRender: (text, record, index) => {
  //     return { 1: "D2C", 2: "B2B" }[text];
  //   },
  // },
  {
    title: "目标库区",
    dataIndex: "targetName",
    key: "targetName",
  },
  {
    title: "创建人",
    dataIndex: "createrName",
    key: "createrName",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "确认人(驳回人)",
    dataIndex: "confirmPerson",
    key: "confirmPerson",
  },
  {
    title: "确认时间(驳回时间)",
    dataIndex: "confirmTime",
    key: "confirmTime",
  },
  {
    title: "件数",
    dataIndex: "amount",
    key: "amount",
    customRender: (text, record, index) => {
      let num = 0;
      record.items.forEach((item) => {
        num += item.amount;
      });
      return num;
    },
  },
  // {
  //   title: "操作",
  //   dataIndex: "action",
  //   key: "action",
  //   scopedSlots: {
  //     customRender: "action",
  //   },
  // },
];

export const colItem = [
  {
    title: "批次包编码",
    dataIndex: "pkgCode",
    key: "pkgCode",
  },
  {
    title: "商品sku",
    dataIndex: "shopProductSku",
    key: "shopProductSku",
  },
  {
    title: "数量",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "库位",
    dataIndex: "gridCode",
    key: "gridCode",
    customRender: (text, record, index) => {
      return text || "-";
    },
  },
  {
    title: "上架时间",
    dataIndex: "upShelfTime",
    key: "upShelfTime",
    customRender: (text, record, index) => {
      return text || "-";
    },
  },
];
